"use client";

import { FaWhatsapp } from "react-icons/fa";

import {
  createWhatsAppUrl,
  trackWhatsAppClick,
} from "@/components/utilities/whatsappTracking";

const WHATSAPP_NUMBER = "+919000566767";

export default function WhatsAppConsultationButton() {
  const handleClick = () => {
    trackWhatsAppClick("campaign-hero");
  };

  return (
    <a
      href={createWhatsAppUrl(WHATSAPP_NUMBER)}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      aria-label="Book consultation on WhatsApp in 2 minutes"
      className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#25D366] px-5 py-3 text-sm font-bold text-white shadow-lg shadow-green-900/30 transition hover:bg-[#20BA5A] focus:outline-none focus:ring-2 focus:ring-[#25D366] focus:ring-offset-2 focus:ring-offset-black sm:w-auto"
    >
      <FaWhatsapp className="size-5" aria-hidden />
      <span>Book consultation in</span>
      <span className="rounded-full bg-white px-3 py-1 text-[#128C4A]">
        2 minutes
      </span>
    </a>
  );
}
